import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "leading-tight" }
const _hoisted_2 = { class: "text-xs text-gray-400" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Попробовать ещё раз ")

import { computed, onMounted, ref } from "vue";

import { useSchoolMenu } from "@/use/useSchoolMenu";
import { useAsync } from "@/use/useAsync";
import { formatCurrency } from "@/utils";

import UiApp from "@/plugins/ui/components/app/UiApp.vue";
import UiCard from "@/plugins/ui/components/card/UiCard.vue";
import UiSuspense from "@/plugins/ui/components/suspense/UiSuspense.vue";

import UiBtn from "@/plugins/ui/components/button/UiBtn.vue";
import UiTab from "@/components/ui/UiTab.vue";
import UiTabs from "@/components/ui/UiTabs.vue";
import AppSidebar from "@/components/AppSidebar.vue";
import UiCell from "@/plugins/ui/components/cell/UiCell.vue";
import UiAppbar from "@/plugins/ui/components/appbar/UiAppbar.vue";
import UiPlaceholder from "@/plugins/ui/components/placeholder/UiPlaceholder.vue";

import RequestCart from "@/components/RequestCart.vue";
import { useCart } from "@/use/useCart";
import UiAppbarBack from "@/plugins/ui/components/appbar/UiAppbarBack.vue";
import { useRequests } from "@/use/useRequests";
import axios from "axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestCreate',
  setup(__props) {

const { fetchRequestsAvailable, fetchRequestsMenu, requestsMenu } =
  useRequests();
const { addToCart } = useCart();

const errorMessage = ref("");
const filter = ref(-1);
const setFitler = (id: number) => (filter.value = id);

const filteredFoods = computed(
  () =>
    requestsMenu.value?.types?.find((t) => t.id === filter.value)?.foods || []
);

const fetchData = useAsync(async () => {
  errorMessage.value = "";

  await fetchRequestsAvailable().catch((e) => {
    if (axios.isAxiosError(e)) {
      errorMessage.value = e.response?.data.errors?.message || "";
    }
  });

  await fetchRequestsMenu();

  filter.value = requestsMenu.value?.types[0].id || -1;
}, true);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiApp, null, {
    header: _withCtx(() => [
      _createVNode(UiAppbar, { title: "Новый заказ" }, {
        left: _withCtx(() => [
          _createVNode(UiAppbarBack, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
          })
        ]),
        right: _withCtx(() => [
          _createVNode(RequestCart)
        ]),
        _: 1
      })
    ]),
    sidebar: _withCtx(() => [
      _createVNode(AppSidebar)
    ]),
    default: _withCtx(() => [
      (!errorMessage.value)
        ? (_openBlock(), _createBlock(UiSuspense, {
            key: 0,
            onRetry: _cache[2] || (_cache[2] = ($event: any) => (_unref(fetchData).execute())),
            pending: _unref(fetchData).isPending.value,
            failure: _unref(fetchData).isFailure.value,
            success: _unref(fetchData).isSuccess.value,
            variant: "screen",
            "has-retry": ""
          }, {
            default: _withCtx(() => [
              (_unref(requestsMenu))
                ? (_openBlock(), _createBlock(UiTabs, { key: 0 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(requestsMenu).types, ({ name, id }) => {
                        return (_openBlock(), _createBlock(UiTab, {
                          onClick: ($event: any) => (setFitler(id)),
                          key: id,
                          active: filter.value === id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(name), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "active"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(requestsMenu)?.sets.length || _unref(requestsMenu)?.types.length)
                ? (_openBlock(), _createBlock(UiCard, { key: 1 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredFoods), (food) => {
                        return (_openBlock(), _createBlock(UiCell, {
                          onClick: ($event: any) => (_unref(addToCart)(food)),
                          key: food.id,
                          multiline: ""
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_1, _toDisplayString(food.name), 1),
                            _createElementVNode("p", _hoisted_2, " Количество (вес): " + _toDisplayString(food.weight), 1)
                          ]),
                          right: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(formatCurrency)(food.price / 100)), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(UiPlaceholder, {
                    key: 2,
                    icon: "EmojiSad",
                    title: "Меню не найдено",
                    description: "К сожалению, в вашей школе меню на сегодня отсутствует",
                    screen: ""
                  }, {
                    action: _withCtx(() => [
                      _createVNode(UiBtn, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(fetchData).execute())),
                        size: "md",
                        variant: "secondary"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }, 8, ["pending", "failure", "success"]))
        : (_openBlock(), _createBlock(UiPlaceholder, {
            key: 1,
            icon: "X",
            title: "ОБЕДОМАТ недоступен",
            description: errorMessage.value,
            screen: ""
          }, null, 8, ["description"]))
    ]),
    _: 1
  }))
}
}

})